import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { FiltersMyPublicationsContainerProps } from "../../../../interfaces/containers";
import Filters from "../../../../pages/Profile/MyPublications/EntryPoint/Filters";
import { getBranches, cleanBranches, getSellers, cleanSellers } from "../../../../actions/profile";
import { 
    getStatusPublication, 
    cleanStatusPublication, 
    setStatesMyPublications,
    setBranchesMyPublications,
    setYearsMyPublications,
    setSellersMyPublications
} from "../../../../actions/myPublications";

function mapStateToProps(state: FiltersMyPublicationsContainerProps) {
    return{
        user: state.auth.user,
        branches: state.profile.branches,
        sellers: state.profile.sellers,
        status: state.profile.status,
        filters: state.profile.myPublications.filters
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getBranches,
        cleanBranches,
        getSellers,
        cleanSellers,
        getStatusPublication,
        cleanStatusPublication,
        setStatesMyPublications,
        setBranchesMyPublications,
        setYearsMyPublications,
        setSellersMyPublications
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);